import { Chart } from '@frontend/chart/types';

import { createStackedTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

const stacked = createStackedTimeSeriesMockData({ days: 30, scale: 0.4 });

export const IOTS_VOLUME_BY_STATUS_BAR_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'online',
            data: stacked.series[0].data.map((point) => ({ ...point, value: Math.max(20, point.value) }))
        },
        {
            name: 'offline',
            data: stacked.series[1].data.map((point, index) => ({
                ...point,
                value: index % 5 === 0 ? Math.max(1, Math.round(point.value * 0.15)) : 0
            }))
        },
        {
            name: 'none',
            data: stacked.series[0].data.map((point, index) => ({
                ...point,
                value: index % 7 === 0 ? 2 : 1
            }))
        }
    ]
};
